import FJNetworkStore from './FJNetworkStore.js';
import FJEvent from './FJEvent.js';

let _animationFrame = null;
let _startTime = null;

const FJLimitedCouponStore = {
    isUsedCoupon: function (startLimitedTime = true, callback) {
        if (window.user_limited_time_coupon_info) {
            let tempData = window.user_limited_time_coupon_info;
            if (tempData) {
                const { expired_at, status } = tempData;
                const nowTime = new Date().getTime();
                const expireTime = expired_at * 1000;
                const diffTime = expireTime - nowTime;
                if (status === 1) {
                    // 已经使用
                    return false;
                } else {
                    if (diffTime > 0) {
                        // 折扣中
                        window.fj?.event?.dispatch('UPDATE_DISCOUNT_COUNT_DOWN', tempData);
                        return true;
                    } else {
                        // 过期
                        return false;
                    }
                }
            }
        } else {
            FJNetworkStore.getLimitedTimeCouponInfo(startLimitedTime).then(data => {
                if (!data) return;
                window.user_limited_time_coupon_info = data;

                // TODO 界面更新
                window.updateLimitedTimeCouponInfo && window.updateLimitedTimeCouponInfo(data);
                window.fj?.event?.dispatch('UPDATE_DISCOUNT_COUNT_DOWN', data);
                FJEvent.dispatch('UPDATE_COUPON_DATA', data);
                callback && callback();
            });
        }
        return true;
    },

    /**
     * @desc 开始倒计时
     * @param {number} time - 倒计时时间（毫秒）
     */
    startCountdown: function (time) {
        if (_animationFrame || time <= 0) return;

        const updateTimer = timestamp => {
            if (!_startTime) {
                _startTime = timestamp; // 初始化开始时间
            }

            const elapsedTime = timestamp - _startTime; // 计算经过的时间（毫秒）
            const remainingTime = time - elapsedTime; // 计算剩余时间

            if (remainingTime > 0) {
                FJEvent.dispatch('UPDATE_COUNTDOWN', remainingTime);
                _animationFrame = requestAnimationFrame(updateTimer); // 继续更新
            } else {
                _animationFrame = null;
                FJEvent.dispatch('UPDATE_COUNTDOWN', 0);
            }
        };
        _animationFrame = requestAnimationFrame(updateTimer);
    },
};

export default FJLimitedCouponStore;
